import React from "react";
import Select from "react-select";

import "./LeftLabelSelect.css";

export const LeftLabelSelect = ({labelText, options, onChange, optionLabel, optionValue, value}) => {

    return (
        <div className="left-label-select-container">
            <label>{labelText}</label>
            <Select options={options}
                    onChange={onChange}
                    getOptionLabel={optionLabel}
                    getOptionValue={optionValue}
                    classNamePrefix="left-label-select"
                    value={value}
            />
        </div>
    );
}